// {{booking_request_link:<templateId>}} — the send-time booking-form link
// placeholder for messaging rules. Single source of truth for the token shape,
// shared by:
//   - server/utils/booking-link-placeholder.ts (send-time resolution)
//   - the client rule form (missing-link confirmation dialog + placeholder
//     preview). The token is OPTIONAL for New Booking rules — the server
//     accepts a tokenless rule; the client warns via an explicit confirm
//     dialog because submissions then aren't tracked by PadPulse.

// Non-global on purpose: a `g` regex's .test()/.exec() are stateful via
// lastIndex and would alternate across calls. Callers that need to iterate
// matches should construct their own global copy from `source`.
export const BOOKING_REQUEST_LINK_TOKEN_RE = /\{\{booking_request_link:(\d+)\}\}/;

export function messageHasBookingRequestLinkToken(body: string | null | undefined): boolean {
  return !!body && BOOKING_REQUEST_LINK_TOKEN_RE.test(body);
}

// Warning copy shown in the client confirmation dialog when a host saves a
// "New Booking" rule whose message is missing the booking-form link. The
// server accepts such rules; this is a deliberate-consent warning only.
export const NEW_BOOKING_RULE_LINK_MISSING_WARNING =
  "Without a booking request link, booking submissions will not be tracked by PadPulse, and you'll need to approve or reject each booking request manually on PadSplit.";
